import React, { useState } from 'react';

import GalleryItem from '@pages/Gallery/GalleryList/GalleryItem';
import { IgalleryItem } from '@typings/pages/gallery.interface';
import StaggerMotionWrapper from '@components/wrapper/StaggerMotionWrapper';
import GalleryDetailModal from '../Detail/GalleryDetailModal';
import GalleryDetail from '../Detail/GalleryDetail';
import { PAGE_LAYOUT_TYPE, PAGE_LAYOUT_TYPE_VALUE } from '@typings/pages/pageLayout.interface';

interface Props {
  list: IgalleryItem[] | any;
  style?: React.CSSProperties;
  isEdit?: boolean;
  collectionPath: string;
  line: number;
  isExtendsModal: boolean;
  contentHeight: string;
  docLayout: PAGE_LAYOUT_TYPE_VALUE;
}

function GalleryList({
  list,
  isEdit,
  collectionPath,
  line,
  isExtendsModal,
  contentHeight,
  docLayout,
}: Props) {
  const [detailOpen, setDetailOpen] = useState(false);
  const [docId, setDocId] = useState<string>('');
  const close = () => setDetailOpen(false);
  const isMasonry = docLayout === PAGE_LAYOUT_TYPE.MASONRY;

  if (!list) return null;

  return (
    <>
      <StaggerMotionWrapper line={line}
        direction={isMasonry ? 'masonry' : undefined}
      >
        {list.map((list, i) => {
          return (
            <div
              key={i}
              onClick={() => {
                setDetailOpen(true);
                setDocId(list.id || list.objectID);
              }}
            >
              <GalleryItem
                list={list}
                isEdit={isEdit}
                collectionPath={collectionPath}
                contentHeight={contentHeight}
              docLayout={docLayout}
              />
            </div>
          );
        })}
      </StaggerMotionWrapper>

      {detailOpen &&
        (isExtendsModal ? (
          <GalleryDetail docId={docId || ''} close={close} />
        ) : (
          <GalleryDetailModal docId={docId || ''} close={close} />
        ))}
    </>
  );
}

export default GalleryList;
